export default __webpack_public_path__ + "static/media/RubbishBinButton.24571acd.svg";